import * as React from "react";

const ChartOpenFinanceIcon = (props) => (
  <svg
    width={72}
    height={72}
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.75 62.2498V57.5307L13.1537 54.127V62.2498H9.75ZM22.0384 62.2498V45.5307L25.4422 42.127V62.2498H22.0384ZM34.298 62.2498V42.127L37.7018 45.6057V62.2498H34.298ZM46.5865 62.2498V45.6057L49.9903 42.202V62.2498H46.5865ZM58.8461 62.2498V33.5307L62.2499 30.127V62.2498H58.8461ZM9.75 44.0594V39.2711L29.9999 19.1134L41.9999 31.1134L62.2499 10.8174V15.6346L41.9999 35.9306L29.9999 23.9306L9.75 44.0594Z"
      fill="url(#paint0_linear_1585_8879)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1585_8879"
        x1={62.2498}
        y1={16.9838}
        x2={1.7605}
        y2={34.2862}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#41B0F8" />
        <stop offset={0.505208} stopColor="#626DFD" />
        <stop offset={1} stopColor="#7232FB" />
      </linearGradient>
    </defs>
  </svg>
);
export default ChartOpenFinanceIcon;
